import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { IStation } from "./models/station";

export const createRouteForm = (formBuilder: FormBuilder) => {
  return formBuilder.group(
    {
      from: [null, Validators.required],
      to: [null, Validators.required],
    },
    { validators: identicalStationsValidator },
  );
};

export function identicalStationsValidator(routeForm: FormGroup): {
  [key: string]: boolean;
} {
  const fromStation = routeForm.get("from").value as IStation;
  const toStation = routeForm.get("to").value as IStation;
  if (fromStation == null || toStation == null) return null;
  return fromStation.id === toStation.id ? { identical: true } : null;
}
